const getters = {
    seasonOnParcelHasCulture: state => state.seasonOnParcelHasCulture,
    spcWorks: state => state.spcWorks,
    spcWorkSummary: state => state.spcWorkSummary,
    spcMachines: state => state.spcMachines,
    spcParcels: state => state.spcParcels,
    spcBulkWorks: state => state.spcBulkWorks,
  }

  export default getters;
